
const STORAGE_KEY = 'userData';

const hasUserData = () => {
    return localStorage.getItem(STORAGE_KEY) !== null;
};

const getUserData = (cb) => {
    const userData = localStorage.getItem(STORAGE_KEY);
    if (userData) {
        try {
            cb(JSON.parse(userData));
        } catch (error) {
            console.error("Error parsing user data:", error);
            cb(null);
        }
    } else {
        cb(null);
    }
};

const UserUtils = {
    hasUserData,
    getUserData
};

export default UserUtils;